import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function ForWhomSection() {
  return <section className="bg-soft-gray py-8 md:py-20 px-3 md:px-4" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl md:rounded-2xl p-4 md:p-10 border border-gold/20 shadow-lg text-center" data-id="element-94">
          <div className="flex justify-center mb-3 md:mb-6" data-id="element-95">
            <div className="bg-gold/10 p-3 md:p-5 rounded-full" data-id="element-96">
              <ShieldCheckIcon className="w-8 h-8 md:w-14 md:h-14 text-gold" data-id="element-97" />
            </div>
          </div>

          <h2 className="text-lg md:text-4xl font-bold text-navy mb-2 md:mb-4" data-id="element-98">
            Garantía de Satisfacción Total
          </h2>

          <p className="text-xs md:text-lg text-navy/70 mb-3 md:mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-99">
            Si dentro de los primeros{' '}
            <strong className="text-navy" data-id="element-100">7 días</strong> sentís que el método
            no es para vos, te devolvemos el 100% de tu dinero. Sin preguntas,
            sin vueltas, sin complicaciones.
          </p>

          <div className="bg-navy/5 rounded-lg md:rounded-xl p-3 md:p-6 mb-3 md:mb-6" data-id="element-101">
            <p className="text-xs md:text-base text-navy/80 leading-relaxed" data-id="element-102">
              Creemos tanto en este método que asumimos todo el riesgo por vos.
              Si aplicás los pasos y no ves mejoras, simplemente escribinos y te
              hacemos la devolución completa. Así de simple.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-navy/60" data-id="element-103">
            <div className="flex items-center gap-1.5 md:gap-2 text-[11px] md:text-sm font-medium" data-id="element-104">
              <span className="text-gold" data-id="element-105">✓</span> 7 días de garantía
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 text-[11px] md:text-sm font-medium" data-id="element-106">
              <span className="text-gold" data-id="element-107">✓</span> Devolución 100%
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 text-[11px] md:text-sm font-medium" data-id="element-108">
              <span className="text-gold" data-id="element-109">✓</span> Sin preguntas
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}